/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const typeIcon = {
  success: 'iconsminds-check',
  error: 'iconsminds-close',
  warning: 'iconsminds-danger',
  info: 'iconsminds-information',
  primary: 'iconsminds-medal',
  secondary: 'iconsminds-information',
};

const Notification = ({
  title,
  type,
  message,
  customClassName,
  timeOut,
  onClick,
  onRequestHide,
}) => {
  const requestHide = () => {
    if (onRequestHide) {
      onRequestHide();
    }
  };

  useEffect(() => {
    let timer = null;
    if (timeOut !== 0) {
      timer = setTimeout(requestHide, timeOut);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    requestHide();
  };

  const className = classnames([
    'notification',
    `notification-${type}`,
    customClassName,
  ]);

  return (
    <div
      className={className}
      onClick={() => handleClick()}
      style={{ '--notif-timeout': `${timeOut}ms` }}
    >
      <div className="notification-icon-badge">
        <i className={typeIcon[type] || 'iconsminds-information'} />
      </div>
      <div className="notification-message" role="alert">
        {title && <p className="title">{title}</p>}
        <p className="message">{message}</p>
      </div>
      <button
        type="button"
        className="notification-close-btn"
        onClick={(e) => { e.stopPropagation(); requestHide(); }}
      >
        ×
      </button>
      {timeOut !== 0 && <div className="notification-progress" />}
    </div>
  );
};

Notification.propTypes = {
  type: PropTypes.oneOf([
    'info',
    'success',
    'warning',
    'error',
    'primary',
    'secondary',
  ]),
  title: PropTypes.node,
  message: PropTypes.node,
  timeOut: PropTypes.number,
  onClick: PropTypes.func,
  onRequestHide: PropTypes.func,
  customClassName: PropTypes.string,
};

Notification.defaultProps = {
  type: 'info',
  title: null,
  message: null,
  timeOut: 5000,
  onClick: () => {},
  onRequestHide: () => {},
  customClassName: '',
};

export default Notification;
